import { toGoLangInvoke } from "../../api-polyfill/src/common/windowFunctions";
import { PromiseWrapper } from "../../api-polyfill/src/utils/pw";
import parseArgs from "minimist";
const fsblServiceAppConfig = {
    "title": "FSBL Service",
    "type": "window",
    "name": "fsbl-service",
    "hidden": true,
    "allowLogging": true,
    "ignoreSavedLayout": true,
    "ignoreFromLayouts": true,
    "service": false,
    "allowCLAAccess": true,
    "details": {
        "url": "http://127.0.0.1:3005/packages/finsemble-service/dist/index.html",
        "isSticky": false,
        "height": 200,
        "width": 200,
        "left": 0,
        "top": 0,
        "hidden": true,
        "mode": "html",
        "channelSelector": {
            "enabled": false
        },
        "allowFeedback": false,
        "allowClose": false,
        "allowMinimize": false,
        "allowMaximize": false,
        "allowAuthInfo": true,
        "allowEnvVars": true
    }
};
const centralLoggerAppConfig = {
    "title": "Central Logger",
    "type": "window",
    "name": "central-logger",
    "hidden": true,
    "allowLogging": true,
    "ignoreSavedLayout": true,
    "ignoreFromLayouts": true,
    "details": {
        "url": "http://localhost:3457/",
        "isSticky": false,
        "width": 1250,
        "height": 1000,
        "hidden": true
    }
};
const main = async (glue) => {
    let timer = null;
    try {
        const context = await glue.windows.my()?.getContext();
        console.log(`Bootstrapping central logger and finsemble service`);
        const { data } = await toGoLangInvoke(() => glue.interop.invoke("T42.GD.Execute", { command: "get-cli-arguments" }));
        const parsedArgs = parseArgs(data?.args ?? []);
        const claManifest = parsedArgs["manifest"];
        if (claManifest) {
            console.log("Overriding manifest from command line argument", claManifest);
        }
        const manifestURL = claManifest ? claManifest : context.manifestURL;
        if (!manifestURL) {
            glue.windows.my()?.setVisible(true);
            document.body.innerText = "manifestURL is empty!";
            return;
        }
        console.log(`manifestURL is ${manifestURL}`);
        const pw1 = new PromiseWrapper();
        const pw2 = new PromiseWrapper();
        timer = setTimeout(() => {
            glue.windows.my()?.show();
            document.body.innerText = "Finsemble bootstrapper failed. Check dev tools for errors. Check application.log for fsbl-service startup.";
        }, 15000);
        glue.interop.register("fsbl-service-started", () => {
            pw1.resolve();
        });
        glue.interop.register("fsbl-service-ready-for-user-stage", () => {
            pw2.resolve();
        });
        if (!context.testMode) {
            fsblServiceAppConfig.details.url = new URL("../../build/polyfill/finsemble-service/dist/index.html", manifestURL);
            centralLoggerAppConfig.details.url = new URL("../../build/polyfill/central-logger/dist/index.html", manifestURL);
        }
        console.log(`Launching central logger and fsbl-service`, centralLoggerAppConfig, fsblServiceAppConfig);
        await glue.appManager.inMemory.import([fsblServiceAppConfig, centralLoggerAppConfig], "merge");
        glue.appManager.application("central-logger")?.start({});
        glue.appManager.application("fsbl-service")?.start({ manifestURL });
        console.log("Waiting for fsbl-service to signal that it has successfully started...");
        await pw1.promise;
        clearTimeout(timer);
        await pw2.promise;
        console.log("fsbl-service signal received. Now, allowing iocd to continue boot sequence.");
        await glue.interop.invoke("T42.GD.Execute", { command: "signal-app-ready" });
        console.log("Closing this window");
        glue.windows.my()?.close();
    }
    catch (e) {
        glue.windows.my()?.show();
        document.body.innerText = "Finsemble bootstrapper failed. Check dev tools for errors. Check application.log for fsbl-service startup.";
        console.log(e);
        throw e;
    }
};
if (globalThis.glue42gd) {
    const glueFactory = globalThis.Glue;
    glueFactory?.({ appManager: "full", layouts: "full" }).then(async (glue) => {
        globalThis.glue = glue;
        main(glue);
    });
}
